import {planTypeOptions} from 'presentation/pages';
import {formatText} from 'presentation/utils';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';

export function useBeneficiaryCard() {
	const {
		beneficiary: {nmPlano, nmSocialUsuarioC, nmUsuarioC, nuRegistroPlano, tipoPlanoC},
	} = useAccountDataStore(state => state.accountData);

	const userName = nmSocialUsuarioC || nmUsuarioC;

	const beneficiaryCardPlanData = {
		planName: nmPlano,
		userName: formatText(userName),
		nuRegistroPlano: formatText(nuRegistroPlano),
		chipColor: planTypeOptions[tipoPlanoC].color,
		chipLabel: planTypeOptions[tipoPlanoC].label,
		chipLabelColor: planTypeOptions[tipoPlanoC].labelColor,
	};

	return {beneficiaryCardPlanData, tipoPlanoC};
}
